<template>
    <v-container>
        <div class="soli-grey font-weight-bold text-start px-1 pb-4">
            {{ getTitle }}
        </div>
        <v-card class="stripe-shadow soli-round" outlined>
            <v-textarea
                @input="$emit('input', $event)"
                :value="value"
                label="Experience, interests, goals..."
                :placeholder="getTitle"
                auto-grow
                solo
                flat
                hide-details="auto"
                :rules="noteRules"
                ref="textarea"
                @update:error="validate($event)"
            ></v-textarea></v-card
    ></v-container>
</template>

<script>
export default {
    props: {
        value: {},
        lesson: {},
        guest: {},
    },
    data() {
        return {
            noteRules: [
                (v) =>
                    !!v ||
                    "Please provide more information to help your teacher prepare",
                (v) => (v || "").length <= 510 || "Character limit reached",
                (v) =>
                    (v && !!v.trim()) ||
                    "Please provide more information to help your teacher prepare",
            ],
        };
    },
    methods: {
        validate(valid) {
            this.$emit("valid", valid);
        },
    },
    computed: {
        getTitle() {
            let subject = this.guest.child_first_name
                ? `${this.guest.child_first_name}'s`
                : "your";

            return ` What is ${subject} experience with ${(this.lesson.instrument?.name).toLowerCase()} and in music? This will help ${
                this.lesson.teacher.name
            } prepare for this lesson.`;
        },
    },
    mounted() {
        this.$emit("mounted");
        this.validate(!this.value?.length > 0);
    },
};
</script>

<style></style>
